module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25233",
      "conversations-internal-schema": "static-1.12224",
      "head-dlb": "static-1.4465",
      "hs-test-utils": "static-1.7503",
      "hubspot-url-utils": "static-1.3781",
      "HubStyleTokens": "static-2.11026",
      "I18n": "static-7.1506",
      "jasmine-runner": "static-1.5984",
      "quartz": "static-1.6373",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.481",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5736",
      "enviro": "static-4.345",
      "hs-promise-rejection-tracking": "static-1.4918",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "raven-hubspot": "static-1.5693",
      "bend-plugin-trellis-migration": "static-1.3045",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1401",
      "hub-http": "static-1.5499",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4114",
      "quartz-config": "static-1.151",
      "quartz-core": "static-1.5592",
      "transmute": "static-2.77",
      "HeadJS": "static-2.659",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7109",
      "framer-motion": "static-1.61",
      "hs-test-utils-bend-plugin": "static-1.2614",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.143",
      "foundations-theming": "static-1.3933",
      "i18n-data": "static-1.214",
      "metrics-js": "static-1.9246",
      "moment-timezone": "static-5.76",
      "react-utils": "static-2.4961",
      "jasmine": "static-4.3832",
      "history": "static-4.47",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.57",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7973",
      "visitor-ui-component-library-icons": "static-1.5547",
      "bender-build-tools": "static-1.2706",
      "rpc-client-utils": "static-1.4213",
      "ts-schema": "static-1.3728",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.128",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.738",
      "hubspotter-http": "static-1.4254",
      "icons": "static-2.601",
      "mobile-manifest-mixins": "static-1.432",
      "quartz-auth": "static-1.48",
      "quartz-head": "static-1.38",
      "quartz-i18n": "static-1.48",
      "quartz-test": "static-1.48",
      "quick-fetch": "static-1.3551",
      "react-rhumb": "static-1.16232",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.337",
      "bend-plugin-foundations-components": "static-1.3378",
      "floating-ui": "static-1.49",
      "foundations-assets": "static-1.4395",
      "foundations-theming-specialty": "static-1.1649",
      "hs-story-utils": "static-1.8923",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.90",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.813",
      "ui-images": "static-2.1019",
      "bend-plugin-foundations-theming": "static-1.2416",
      "foundations-theming-base": "static-1.2918",
      "stylex": "static-1.25",
      "classnames": "static-2.10",
      "cssUtils": "static-1.659",
      "HubStyle": "static-2.11334",
      "sassPrefix": "static-1.148",
      "hub-http-shared-msw-handlers": "static-1.8963",
      "hubspotter-http-shared-msw-handlers": "static-1.8961",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25233",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12224",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-test-utils": "/hs-test-utils/static-1.7503",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3781",
      "HubStyleTokens": "/HubStyleTokens/static-2.11026",
      "I18n": "/I18n/static-7.1506",
      "jasmine-runner": "/jasmine-runner/static-1.5984",
      "quartz": "/quartz/static-1.6373",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5736",
      "enviro": "/enviro/static-4.345",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3045",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1401",
      "hub-http": "/hub-http/static-1.5499",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4114",
      "quartz-config": "/quartz-config/static-1.151",
      "quartz-core": "/quartz-core/static-1.5592",
      "transmute": "/transmute/static-2.77",
      "HeadJS": "/HeadJS/static-2.659",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7109",
      "framer-motion": "/framer-motion/static-1.61",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2614",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.143",
      "foundations-theming": "/foundations-theming/static-1.3933",
      "i18n-data": "/i18n-data/static-1.214",
      "metrics-js": "/metrics-js/static-1.9246",
      "moment-timezone": "/moment-timezone/static-5.76",
      "react-utils": "/react-utils/static-2.4961",
      "jasmine": "/jasmine/static-4.3832",
      "history": "/history/static-4.47",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.57",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7973",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5547",
      "bender-build-tools": "/bender-build-tools/static-1.2706",
      "rpc-client-utils": "/rpc-client-utils/static-1.4213",
      "ts-schema": "/ts-schema/static-1.3728",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.128",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.738",
      "hubspotter-http": "/hubspotter-http/static-1.4254",
      "icons": "/icons/static-2.601",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.432",
      "quartz-auth": "/quartz-auth/static-1.48",
      "quartz-head": "/quartz-head/static-1.38",
      "quartz-i18n": "/quartz-i18n/static-1.48",
      "quartz-test": "/quartz-test/static-1.48",
      "quick-fetch": "/quick-fetch/static-1.3551",
      "react-rhumb": "/react-rhumb/static-1.16232",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.337",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3378",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-assets": "/foundations-assets/static-1.4395",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1649",
      "hs-story-utils": "/hs-story-utils/static-1.8923",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.90",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.813",
      "ui-images": "/ui-images/static-2.1019",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2416",
      "foundations-theming-base": "/foundations-theming-base/static-1.2918",
      "stylex": "/stylex/static-1.25",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.659",
      "HubStyle": "/HubStyle/static-2.11334",
      "sassPrefix": "/sassPrefix/static-1.148",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8963",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8961",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};